<template>
  <div class="container-fluid">
    <div class="consent-form">
      <div class="note-wrap">
        <div class="letter-title">個資同意書</div>
      </div>
      <form>
        <div class="info-wrap">
          <div class="field-wrap">
            <div class="form-group">
              <label for="select-version">{{ i18n("Template.Version") }}</label>
              <select
                id="select-version"
                class="form-control"
                v-model="latestVersion"
                @change="getPersonalStatementInfo"
              >
                <option
                  v-for="item in versionHistory"
                  :key="item.Guid"
                  :value="item.Guid"
                >
                  {{ item.Version }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <label for="input-title">
                  <span class="mark">*</span>
                  標題
                </label>
                <input
                  type="text"
                  id="input-title"
                  maxlength="50"
                  class="form-control"
                  v-model.trim="title"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                :name="i18n('Template.Content')"
                rules="required"
                v-slot="{ errors }"
              >
                <label for="">
                  <span class="mark">*</span>
                  {{ i18n("Template.Content") }}
                </label>
                <VueEditor
                  style="background: rgb(255, 255, 255)"
                  v-model="content"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="button-wrap center">
          <button
            type="button"
            class="btn btn-info"
            style="margin-right: 5px"
            @click="createPersonalStatement"
          >
            {{ i18n("Buttons.CreateNewVersion") }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="margin-left: 5px"
            @click="updatePersonalStatement"
          >
            {{ i18n("Buttons.Save") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "ConsentForm",

  data() {
    return {
      // 歷史版本
      versionHistory: [],
      // 最新版本
      latestVersion: null,
      // 個資聲明
      title: "",
      content: "",
    };
  },

  methods: {
    // 取得 個資聲明
    getPersonalStatementInfo() {
      this.updateLoading(true);
      this.$api.personalStatement
        .getPersonalStatement(this.latestVersion)
        .then((response) => {
          if (response.status === 200) {
            this.title = response.data.Title;
            this.content = response.data.Content;
          }
          this.updateLoading(false);
        });
    },

    // 編輯 個資聲明
    updatePersonalStatement() {
      this.updateLoading(true);
      this.$api.personalStatement
        .putPersonalStatement({
          Title: this.title,
          Content: this.content,
          Guid: this.latestVersion,
          UpdateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "編輯成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
        });
    },

    // 建立 新版個資聲明
    createPersonalStatement() {
      this.updateLoading(true);
      this.$api.personalStatement
        .postPersonalStatement({
          Title: this.title,
          Content: this.content,
          OriginalGuid: this.latestVersion,
          CreateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "建立成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
          this.getData();
        });
    },

    async getData() {
      await this.$http
        .all([
          this.$api.personalStatement.getLatestPersonalStatement(),
          this.$api.personalStatement.getPersonalStatementHistory(),
        ])
        .then(
          this.$http.spread((latest, history) => {
            // 取得 個資聲明最新版本
            this.latestVersion = latest.data.Guid;
            // 取得 個資聲明歷史版本
            this.versionHistory = history.data;
            this.getPersonalStatementInfo();
          })
        );
      
    },
    
    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  created() {
    this.getData();
  },
};
</script>
